// extracted by mini-css-extract-plugin
module.exports = {"button":"button-icon-element_button__8PVXH","disabled":"button-icon-element_disabled__1ZRYq"};